import { Column } from 'ag-grid-community';

export function getExportColumnOrder(
  columnState: Column[],
  allowedExportColumns: Record<string, string>,
): (keyof typeof allowedExportColumns)[] {
  const fixedDonorBlock: (keyof typeof allowedExportColumns)[] = [
    'donorName',
    'donorBreed',
    'sireName',
    'sireBreed',
    'sireReg',
  ];

  const tailBlock: (keyof typeof allowedExportColumns)[] = ['colCode', 'cane'];

  const fixedSet = new Set([
    ...fixedDonorBlock,
    'totals',
    'Export',
    ...tailBlock,
  ]);

  const columnIds: (keyof typeof allowedExportColumns)[] = columnState
    ?.map((col) => col.getColId())
    .filter((colId): colId is keyof typeof allowedExportColumns =>
      Object.hasOwn(allowedExportColumns, colId),
    );

  const userDefined = columnIds?.filter((col) => !fixedSet.has(col));

  let finalColumnIds: (keyof typeof allowedExportColumns)[] = [];

  finalColumnIds.push(...userDefined.slice(0, 2));
  finalColumnIds.push(...fixedDonorBlock);
  finalColumnIds.push(...userDefined.slice(2));

  const qualityIndex = finalColumnIds.indexOf('predictedGood');
  const lowIndex = finalColumnIds.indexOf('predictedVeryLow');
  const totalsInsertAt = Math.max(qualityIndex, lowIndex) + 1;

  finalColumnIds = [
    ...finalColumnIds.slice(0, totalsInsertAt),
    'totals',
    ...finalColumnIds.slice(totalsInsertAt),
  ];

  finalColumnIds = [
    ...finalColumnIds.slice(0, 16),
    'Export',
    ...finalColumnIds.filter((id) => id !== 'Export').slice(16),
  ];

  finalColumnIds = [...finalColumnIds, ...tailBlock];

  const seen = new Set<string>();
  return finalColumnIds.filter((col) => {
    if (seen.has(col)) return false;
    seen.add(col);
    return true;
  });
}

export function getExportColumnOrderWithPTA(
  columnState: Column[],
  allowedExportColumnsWithPTA: Record<string, string>,
): (keyof typeof allowedExportColumnsWithPTA)[] {
  const fixedDonorBlock: (keyof typeof allowedExportColumnsWithPTA)[] = [
    'donorName',
    'donorBreed',
    'sireName',
    'sireBreed',
  ];

  const tailBlock: (keyof typeof allowedExportColumnsWithPTA)[] = [
    'colCode',
    'cane',
    'embryoCalcPaTpi',
    'embryoCalcPaNm',
  ];

  const fixedSet = new Set([
    ...fixedDonorBlock,
    'totals',
    'Export',
    ...tailBlock,
  ]);

  const columnIds: (keyof typeof allowedExportColumnsWithPTA)[] = columnState
    ?.map((col) => col.getColId())
    .filter((colId): colId is keyof typeof allowedExportColumnsWithPTA =>
      Object.hasOwn(allowedExportColumnsWithPTA, colId),
    );

  const userDefined = columnIds.filter((col) => !fixedSet.has(col));

  let finalColumnIds: (keyof typeof allowedExportColumnsWithPTA)[] = [];

  finalColumnIds.push(...userDefined.slice(0, 2));
  finalColumnIds.push(...fixedDonorBlock);
  finalColumnIds.push(...userDefined.slice(2));

  const qualityIndex = finalColumnIds.indexOf('predictedGood');
  const lowIndex = finalColumnIds.indexOf('predictedVeryLow');
  const totalsInsertAt = Math.max(qualityIndex, lowIndex) + 1;

  finalColumnIds = [
    ...finalColumnIds.slice(0, totalsInsertAt),
    'totals',
    ...finalColumnIds.slice(totalsInsertAt),
  ];

  finalColumnIds = [
    ...finalColumnIds.slice(0, 16),
    'Export',
    ...finalColumnIds.filter((id) => id !== 'Export').slice(16),
  ];

  finalColumnIds = [...finalColumnIds, ...tailBlock];

  const seen = new Set<string>();
  return finalColumnIds.filter((col) => {
    if (seen.has(col)) return false;
    seen.add(col);
    return true;
  });
}
